const initialState = {
  cameraIP: [],
  ptzCameraIP: [],
  ptzCameraPcitizen: null,
  ptzCameraIPRight: null,
  ptzCameraIPLeft: null
}

const cameraIP = (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_CAMERA_IP":
      return { ...state, cameraIP: action.val?.length !== 0 ? [...state.cameraIP, action.val] : [] }
    case "SAVE_PTZ_CAMERA_IP":
      return { ...state, ptzCameraIP: action.val?.length !== 0 ? [...state.ptzCameraIP, ...action.val] : [] }
    case "SAVE_PTZ_CAMERA_IP_RIGHT":
      return { ...state, ptzCameraIPRight: action.val }
    case "SAVE_PTZ_CAMERA_IP_LEFT":
      return { ...state, ptzCameraIPLeft: action.val }
    case "SAVE_PTZ_CAMERA_PCITIZEN":
      return { ...state, ptzCameraPcitizen: action.val }

    default:
      return state
  }
}
export default cameraIP
